var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useContext } from "react";
import { Page } from "react-pdf";
import styled from "styled-components";
import { PDFContext } from "../../state";
var PDFSinglePage = function (props) {
    var pageNum = props.pageNum;
    var _a = useContext(PDFContext).state, mainState = _a.mainState, paginated = _a.paginated, zoomLevel = _a.zoomLevel, numPages = _a.numPages, currentPage = _a.currentPage;
    var rendererRect = (mainState === null || mainState === void 0 ? void 0 : mainState.rendererRect) || null;
    var _pageNum = pageNum || currentPage;
    return (React.createElement(PageWrapper, { id: "pdf-page-wrapper", last: _pageNum >= numPages },
        !paginated && (React.createElement(PageTag, { id: "pdf-page-info" },
            "Page ",
            _pageNum,
            "/",
            numPages)),
        React.createElement(Page, { pageNumber: _pageNum || currentPage, scale: zoomLevel, height: ((rendererRect === null || rendererRect === void 0 ? void 0 : rendererRect.height) || 100) - 100, width: ((rendererRect === null || rendererRect === void 0 ? void 0 : rendererRect.width) || 100) - 100 })));
};
export default PDFSinglePage;
var PageWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px 0;\n"], ["\n  margin: 20px 0;\n"])));
var PageTag = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 0 10px 10px;\n  color: ", ";\n  font-size: 14px;\n  text-align: left;\n\n  @media (max-width: 768px) {\n    font-size: 10px;\n  }\n"], ["\n  padding: 0 0 10px 10px;\n  color: ", ";\n  font-size: 14px;\n  text-align: left;\n\n  @media (max-width: 768px) {\n    font-size: 10px;\n  }\n"])), function (props) { return props.theme.text_tertiary; });
var templateObject_1, templateObject_2;
